export default __webpack_public_path__ + "static/media/Update1.89623ba7.png";